import { Injectable } from '@angular/core';
import {HttpClient,HttpHeaders} from '@angular/common/http';
import { Empleado } from '../models/Empleado';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmpleadoService {

  API_URI = environment.uri_api;
  //'http://localhost:3000';

  constructor(private http: HttpClient) { }

  ///////////////////////empleados por plantel/////////////////
  getEmpleadosPlantel(idplantel: number){
      var t=localStorage.getItem('token');
  
      const httpHeaders=new HttpHeaders({
        'content-type':'application/json',
        'Authorization': ''+t
      });
  
      return this.http.get(`${this.API_URI}/empleados/plantel/${idplantel}`,{headers:httpHeaders});
    }
  /////////////////////// ACTUALIZA EL TUTOR ASIGNADO /////////////////

  

     /////////////////////// GUARDA EL TUTOR ASIGNADO /////////////////


    /////////////////////// OBTIENE LOS TUTORES /////////////////
  
    getTutores(id: number){
      var t=localStorage.getItem('token');
  
      const httpHeaders=new HttpHeaders({
        'content-type':'application/json',
        'Authorization': ''+t
      });
  
      return this.http.get(`${this.API_URI}/empleadostutor/${id}`,{headers:httpHeaders});
    }
      /////////////////////// OBTIENE LOS TUTORES POR GRUPO /////////////////

    getTutoresGrupos(idplantel: number){ //nuevo

      var t=localStorage.getItem('token');
  
      const httpHeaders=new HttpHeaders({
        'content-type':'application/json',
        'Authorization': ''+t
      });
  
      return this.http.get(`${this.API_URI}/empleadostutores/plantel/${idplantel}`,{headers:httpHeaders});
    }
        //////////////////empleado id//////////////////////////
        getEmpleado(id: number){

          var t=localStorage.getItem('token');
      
          const httpHeaders=new HttpHeaders({
            'content-type':'application/json',
            'Authorization': ''+t
          });
      
          return this.http.get(`${this.API_URI}/empleado/${id}`,{headers:httpHeaders});
        }

            //////////////////plantel 2 empleado///////////////////
    EmpleadoPlantelInt(id: number, empleado: Empleado ){

      var t=localStorage.getItem('token');
  
      const httpHeaders=new HttpHeaders({
        'content-type':'application/json',
        'Authorization': ''+t
      });
  
      return this.http.put(`${this.API_URI}/empleadoplantel/${id}`, empleado,{headers:httpHeaders});
    }
            ////////////////// actualizar empleado///////////////////

    updateEmpleado(id: number, empleado: Empleado ){

      var t=localStorage.getItem('token');
  
      const httpHeaders=new HttpHeaders({
        'content-type':'application/json',
        'Authorization': ''+t
      });
  
      return this.http.put(`${this.API_URI}/empleado/${id}`, empleado,{headers:httpHeaders});
    }
                ////////////////// baja empleado///////////////////

    deleteEmpleado(id: number){

      var t=localStorage.getItem('token');
  
      const httpHeaders=new HttpHeaders({
        'content-type':'application/json',
        'Authorization': ''+t
      });
  
      return this.http.delete(`${this.API_URI}/empleado/${id}`,{headers:httpHeaders});
    }
    saveEmpleado(empleado: Empleado ){

      var t=localStorage.getItem('token');
    
      const httpHeaders=new HttpHeaders({
        'content-type':'application/json',
        'Authorization': ''+t
      });
    
      return this.http.post(`${this.API_URI}/empleados`, empleado,{headers:httpHeaders});
    }

    //////////////////DATOS EMPLEADO USUARIO//////////////////////////
            getEmpleadoUsuario(id: number){

              var t=localStorage.getItem('token');
          
              const httpHeaders=new HttpHeaders({
                'content-type':'application/json',
                'Authorization': ''+t
              });
          
              return this.http.get(`${this.API_URI}/empleadoUsuario/${id}`,{headers:httpHeaders});
            }
  
  
    //////////////////DATOS EMPLEADO NOTA//////////////////////////
            getEmpleadoNota(numemp: number,cargo:any){

              var t=localStorage.getItem('token');
          
              const httpHeaders=new HttpHeaders({
                'content-type':'application/json',
                'Authorization': ''+t
              });
          
              return this.http.get(`${this.API_URI}/empleadonota/${numemp}/${cargo}`,{headers:httpHeaders});
            }
  
      //////////////////DATOS GRUPO EMPLEADO //////////////////////////
            empleadogrupo(numemp: number){

              var t=localStorage.getItem('token');
          
              const httpHeaders=new HttpHeaders({
                'content-type':'application/json',
                'Authorization': ''+t
              });
          
              return this.http.get(`${this.API_URI}/empleadogrupo/${numemp}`,{headers:httpHeaders});
            }
  
        //////////////////DATOS CARGA EMPLEADO //////////////////////////
            empleadocarga(numemp: number, idgrupo:any){

              var t=localStorage.getItem('token');
          
              const httpHeaders=new HttpHeaders({
                'content-type':'application/json',
                'Authorization': ''+t
              });
          
              return this.http.get(`${this.API_URI}/empleadocarga/${numemp}/${idgrupo}`,{headers:httpHeaders});
            }
          ////////////////// AGREGAR NOTA DE CAMBIO //////////////////////////

  
    

            ////////////////// AGREGAR NOTA DE CAMBIO //////////////////////////

              listanotas(idplantel: any,cargo:any, numempleado:any){
              var t=localStorage.getItem('token');
          
              const httpHeaders=new HttpHeaders({
                'content-type':'application/json',
                'Authorization': ''+t
              });
          
              return this.http.get(`${this.API_URI}/notalista/${idplantel}/${cargo}/${numempleado}`,{headers:httpHeaders});
            }
  
  
  
      ///////////////////////////////////////////////////////
NotaVerifi(folio: any){
    var t=localStorage.getItem('token');
  
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });
  
    return this.http.put(`${this.API_URI}/notaverificada/${folio}`,{headers:httpHeaders});
  }
  
  
  
     ///////////////////////////////////////////////////////
  
  NotaIncorrecta(folio: any){
    var t=localStorage.getItem('token');
  
    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });
  
    return this.http.put(`${this.API_URI}/notaincorrecta/${folio}`,{headers:httpHeaders});
  }

  

  
}
